import { list, object, serializable } from "serializr"
import Research from "@/Research"
import Farm from "@/farm/Farm"
import Employee from "@/employee/Employee"
import { ResearchItem } from "@/employee/ResearchItem"

export class Inventory {
  private farm: Farm
  private employee: Employee

  @serializable(list(object(ResearchItem)))
  private items: ResearchItem[] = []

  constructor(farm: Farm, employee: Employee) {
    this.farm = farm
    this.employee = employee
  }

  update(dt: number) {
    this.farm.pay(this.ongoingCost * dt)
  }

  get ongoingCost(): number {
    let sum = 0
    for (let item of this.items) {
      if (item.isEquipped) sum += item.research.ongoingCost
    }
    return sum
  }

  addResearch(research: Research) {
    this.items.push(new ResearchItem(research, this.employee, this.farm))

    let lab = this.farm.state.lab
    this.items.sort((a, b) => lab.getResearchIndex(a.research) - lab.getResearchIndex(b.research))
  }

  load(state: any) {
    for (let item of state.items) {
      let research = this.farm.state.lab.researchById(item.research.id)
      if (research == undefined) continue

      let newItem = new ResearchItem(research, this.employee, this.farm)
      newItem.load(item)
      this.items.push(newItem)
    }
  }

  get allItems(): ResearchItem[] {
    return this.items
  }
}
